import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { CommonResponse } from '../../interfaces/common-response';
import { MessageService } from 'primeng/api';
import { RefreshTokenRequest } from '../../interfaces/users/refresh-token-request';

@Injectable({
  providedIn: 'root',
})
export class AuthHttpService {
  constructor(
    private http: HttpClient,
    private messageService: MessageService
  ) {}

  baseUrl = environment.baseUrl;
  baseUrlV2 = environment.baseUrlV2;

  // login
  login(email: string, password: string): Observable<CommonResponse> {
    const url = `${environment.baseUrlV2}auth/login`;
    const body = { email, password };
    return this.http.post<CommonResponse>(url, body).pipe(
      catchError((error) => {
        // Rethrow the error to be handled by the component
        return throwError(() => error);
      })
    );
  }

  // refresh token
  refreshToken(
    refreshTokenRequest: RefreshTokenRequest
  ): Observable<CommonResponse> {
    const url = `${environment.baseUrlV2}token/refresh`;
    const body = refreshTokenRequest;
    return this.http.post<CommonResponse>(url, body);
  }

  // create password
  createPassword(request: any): Observable<CommonResponse> {
    const url = `${environment.baseUrl}Auth/CreatePassword`;
    const body = { request };
    return this.http.post<CommonResponse>(url, body);
  }

  // update password
  updatePassword(request: any): Observable<CommonResponse> {
    const url = `${environment.baseUrl}Auth/UpdatePassword`;
    const body = { request };
    return this.http.post<CommonResponse>(url, body);
  }

  // create user
  createUser(request: any): Observable<CommonResponse> {
    const url = `${environment.baseUrl}Auth/CreateUser`;
    const body = { request };
    return this.http.post<CommonResponse>(url, body);
  }

  show(error: any) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: error.error.message,
    });
  }
}
